
export default class BlockLink {
    constructor(selector = '.js-block-link') {

        // Setup links, if any
        const el_links = document.querySelectorAll(selector);
        if (!el_links) return; // bail if no links

        el_links.forEach( (el) => {
            var link = el.querySelector('a');
            el.addEventListener('click', (event) => link.click(event));
        });

    }
}